const MCP_CONSENT_PATH = '/settings/master/mcp-connection/consent';

export const loginTargetFor = (route) =>
  route?.name === 'mcp-connection-consent'
    ? { name: 'login', query: { redirect: route.fullPath } }
    : { name: 'login' };

export const safeMcpConsentRedirect = (redirect, frontendOrigin) => {
  if (typeof redirect !== 'string') return null;
  try {
    const target = new URL(redirect, frontendOrigin);
    if (
      target.origin === frontendOrigin &&
      target.pathname === MCP_CONSENT_PATH &&
      target.searchParams.has('request_id')
    ) {
      return `${target.pathname}${target.search}`;
    }
  } catch (error) {
    return null;
  }
  return null;
};
